import React from "react";
import { useParams } from "react-router";
import { RefActivity } from "../../../../api/hooks";
import ActivityView from "../../../../common/activity/ActivityView";

const StockTransferActivity = () => {
    const { transferId } = useParams<any>();
    return (
        <div>
            {transferId && (
                <ActivityView
                    className="mt-3 border"
                    activityRef={RefActivity?.ProductStockTransfer}
                    activityRefId={transferId ?? ""}
                />
            )}
        </div>
    );
};

export default StockTransferActivity;
